import { useTranslation } from 'react-i18next';
import { Text } from '../Ant';

const OrganisationRadioCard = ({ organisation }: { organisation: IOrganisation }) => {
  const { t } = useTranslation();

  return (
    <div
      data-testid={`organisation-item-${organisation?.organizationName}`}
      className={`radio-card d-flex ai-center w-full ${!organisation.isOperational ? 'disabled' : ''}`}
    >
      <div className="content d-flex fd-column">
        {!organisation.isOperational && (
          <span
            data-testid={`organisation-unavailable-${organisation?.organizationName}`}
            className="unavailable"
          >
            {t('common:unavailable')}
          </span>
        )}
        <Text
          data-testid={`organisation-name-${organisation?.organizationName}`}
          $weight={500}
          $color="title"
          $fontsize="13px"
          $lineheight="18px"
        >
          {organisation.organizationName}
        </Text>
        <Text
          data-testid={`organisation-url-${organisation?.organizationName}`}
          $weight={400}
          $color="subtitle"
          $fontsize="12px"
          $lineheight="20px"
        >
          {organisation.organizationUrl}
        </Text>
      </div>
    </div>
  );
};

export default OrganisationRadioCard;
